import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { notistackRef } from '@proccess/ref/noti';
import { PayloadAction } from '@reduxjs/toolkit';
import { PATH_DASHBOARD } from '@routes/paths';
import { actions } from '@store';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestServices({
  payload: { page, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get('/admin/services', { params: { page, limit } })
    );

    if (response.data) {
      yield put(actions.saveServices({ list: { ...response.data, limit } }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestServices() {
  yield takeEvery(actions.requestServices, requestServices);
}

function* requestService({ payload: { id } }: any) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() => initSdk.get(`/admin/services/${id}`));

    if (response.data) {
      yield put(actions.saveService({ data: response.data.service }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestService() {
  yield takeLatest(actions.requestService, requestService);
}

function* updateService({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/services/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    console.info('🚀 response:', response.data);

    if (response.data) {
      yield put(actions.saveService({ data: response.data }));
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Cập nhật thành công', { variant: 'success' })
      );

      Router.push(PATH_DASHBOARD.managements.services);
    }
  } catch (error) {
    onApiError(error);
  }
}

function* watcherupdateService() {
  yield takeLatest(actions.updateService, updateService);
}

function* createService({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.post('/admin/services', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );
    console.info('🚀 response:', response.data);

    if (response.data) {
      yield put(actions.saveService({ data: response.data }));
      Router.push(PATH_DASHBOARD.managements.services);
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Tạo mới thành công', { variant: 'success' })
      );
    }
  } catch (error) {
    onApiError(error);
  }
}

function* watcherCreateService() {
  yield takeLatest(actions.createService, createService);
}

function* deleteService({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/services/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      Router.back();
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherDeleteService() {
  yield takeLatest(actions.deleteService, deleteService);
}

const serviceSagas = function* root() {
  yield all([
    fork(watcherRequestServices),
    fork(watcherRequestService),
    fork(watcherupdateService),
    fork(watcherCreateService),
    fork(watcherDeleteService),
  ]);
};
export { serviceSagas };
